// import { CONTACTUS_ARE_LOADING, CONTACTUS_FETCH_DATA_SUCCESS, CONTACTUS_HAVE_ERROR } from '../actionType';
import { INVREL_ARE_LOADING, INVREL_FETCH_DATA_SUCCESS, INVREL_HAVE_ERROR } from '../actionType';
import HttpService from '../../utils/httpService';
import { Get } from '../../services/api.service';

export function InvRelAction(action, payload) {
    switch (action) {
        case INVREL_HAVE_ERROR:
            return {
                type: action,
                hasError: payload
            };
    
        case INVREL_ARE_LOADING:
            return {
                type: action,
                isLoading: payload
            };
    
        case INVREL_FETCH_DATA_SUCCESS:
            return {
                type: action,
                InvRel: payload,
                isLoading:false 
            };

        default:
            return;
    }
}

export function invrelFetchData() {
    return (dispatch) => {
        try {
            return new Promise((resolve, reject) => {
                dispatch(InvRelAction(INVREL_ARE_LOADING, true));
                Get(HttpService?.invrel).then((result) => {
                    dispatch(InvRelAction(INVREL_FETCH_DATA_SUCCESS, result.data));
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            });
        } catch (error) {
            dispatch(InvRelAction(INVREL_HAVE_ERROR, true));
        }
    }
}



